/**
 * Sends event view tracking data using Navigator.sendBeacon or fetch fallback
 * Only runs in browser environment (client-side)
 *
 * @returns Promise<boolean> - true if the request was successfully queued, false otherwise
 */
export const sendEventViewTracking = async (): Promise<boolean> => {
  // Only run in browser environment
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const payload = JSON.stringify({
      path: window.location.pathname + window.location.search,
      host: window.location.host,
    });

    // Use sendBeacon if available (preferred method)
    if (navigator.sendBeacon) {
      return navigator.sendBeacon('/e/api/eventview', payload);
    } else {
      // Fallback to fetch if sendBeacon is not available
      await fetch('/e/api/eventview', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: payload,
        keepalive: true, // Similar behavior to sendBeacon
      });
      return true;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    // Silently ignore errors for tracking
    return false;
  }
};
